import { TextInput, TextInputProps } from '@mezzoforte/forge';
import { forwardRef } from 'react';
import { NumericFormat } from 'react-number-format';

interface CurrencyInputProps extends Omit<TextInputProps, 'value' | 'type' | 'defaultValue'> {
  onValueChange: (value: number | null) => void;
  value: null | number;
}

export const CurrencyInput = forwardRef<HTMLInputElement, CurrencyInputProps>(
  ({ onValueChange, label, value, ...rest }, ref) => (
    <NumericFormat
      getInputRef={ref}
      allowNegative={false}
      customInput={TextInput}
      label={label}
      rightAddon="€"
      decimalScale={0}
      valueIsNumericString
      onValueChange={(values) => {
        onValueChange(values.floatValue ?? null);
      }}
      thousandSeparator=" "
      value={value === null ? '' : String(value)}
      data-test="currency-input"
      {...rest}
    />
  )
);

CurrencyInput.displayName = 'CurrencyInput';
